import LocationForm from "./LocationForm";
import LocationList from "./LocationList";
import LocationsPage from "./LocationsPage";

export default {
    list: LocationsPage,
    create: LocationsPage,
};